import React, { useState } from "react";
import { ArrowUpDown } from "lucide-react";

export default function GSCPagesTable({ data }) {
  const [sortField, setSortField] = useState("impressions");
  const [sortDir, setSortDir] = useState("desc");

  const toggleSort = (field) => {
    if (sortField === field) {
      setSortDir(sortDir === "desc" ? "asc" : "desc");
    } else {
      setSortField(field);
      setSortDir("desc");
    }
  };

  const sorted = [...(data || [])].sort((a, b) => {
    const mul = sortDir === "desc" ? -1 : 1;
    return (a[sortField] - b[sortField]) * mul;
  });

  const SortHeader = ({ field, label }) => (
    <th
      onClick={() => toggleSort(field)}
      className="text-right py-2.5 px-3 font-medium cursor-pointer hover:text-copper select-none"
    >
      <span className="inline-flex items-center gap-1">
        {label}
        {sortField === field && <ArrowUpDown size={10} className="text-copper" />}
      </span>
    </th>
  );

  return (
    <div className="bg-dark-300 border border-dark-50 rounded-xl overflow-hidden">
      <div className="px-5 py-3 border-b border-dark-50">
        <h3 className="text-sm font-semibold text-gray-300">Pages ({sorted.length})</h3>
      </div>
      <div className="overflow-x-auto">
        <table className="w-full text-sm">
          <thead>
            <tr className="text-xs text-gray-500 border-b border-dark-50">
              <th className="text-left py-2.5 px-4 font-medium">URL</th>
              <SortHeader field="impressions" label="Impressions" />
              <SortHeader field="clicks" label="Clicks" />
              <SortHeader field="ctr" label="CTR" />
              <SortHeader field="avg_position" label="Position" />
            </tr>
          </thead>
          <tbody>
            {sorted.map((p, i) => (
              <tr key={i} className="border-b border-dark-50/50 hover:bg-dark-50/30">
                <td className="py-2.5 px-4 font-mono text-xs text-gray-300 truncate max-w-xs">
                  {p.page_url.replace(/^https?:\/\/[^/]+/, "")}
                </td>
                <td className="py-2.5 px-3 text-right font-mono">{p.impressions.toLocaleString()}</td>
                <td className="py-2.5 px-3 text-right font-mono">{p.clicks.toLocaleString()}</td>
                <td className="py-2.5 px-3 text-right font-mono text-gray-400">{(p.ctr * 100).toFixed(2)}%</td>
                <td className="py-2.5 px-3 text-right font-mono text-gray-400">{p.avg_position.toFixed(1)}</td>
              </tr>
            ))}
            {!sorted.length && (
              <tr>
                <td colSpan={5} className="py-12 text-center text-gray-500">No page data available</td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
}
